import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

// Estado de la sincronización AS/400 → Korvantis (tabla as400_sync_estado, la escribe el puente).
// Más de HORAS_MAX sin una carga buena = "bloqueado": se pueden consultar fichas y registrar
// cobros, pero NO hacer ni enviar pedidos (precios y stock podrían estar mal). Decidido 25/10/2026.
export const HORAS_MAX = 26;

export function useSyncAS400(usuario) {
  const [estado, setEstado] = useState({ cargado: false, hayAs400: false, ultima: null });

  useEffect(() => {
    if (!usuario?.empresa_id || usuario?.rol === "superadmin") return undefined;
    let vivo = true;
    const mirar = async () => {
      const { data, error } = await supabase
        .from("as400_sync_estado").select("ultima_ok")
        .eq("empresa_id", usuario.empresa_id).maybeSingle();
      if (!vivo || error) return;          // si no se puede leer, no se bloquea a nadie
      setEstado({ cargado: true, hayAs400: !!data, ultima: data?.ultima_ok || null });
    };
    mirar();
    const t = setInterval(mirar, 10 * 60 * 1000);
    return () => { vivo = false; clearInterval(t); };
  }, [usuario?.empresa_id, usuario?.rol]);

  const horas = estado.ultima ? (Date.now() - new Date(estado.ultima).getTime()) / 3600000 : 0;
  return { ...estado, bloqueado: estado.hayAs400 && !!estado.ultima && horas >= HORAS_MAX };
}

export const fechaSync = (ultima) =>
  ultima ? new Date(ultima).toLocaleString("es-ES", { weekday: "long", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "";
